<div class="no-column-info">
  <p>{{ "page.patientlist.noColumn" | translate }}</p>
</div>
